/* Copyright 2026 Element Creations Ltd.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
 * Please see LICENSE files in the repository root for full details.
 */

/* compound-web sizes link buttons to their content; the extra specificity
 * overrides it so the link stretches like the buttons above it */
a.login-link[href] {
  inline-size: initial;
}
